//Do not delete or edit enum value (REWARDS_POP_UP_WIDGET = "RewardsPopUpWidget"),
//                                                           ^^^^^^^^^^^^^^^^^^

export enum REWARDS_WIDGET_NAMES {
    REWARDS_DRAWER_WIDGET = "RewardsDrawerWidget",
    REWARDS_POP_UP_WIDGET = "RewardsPopUpWidget",
    REWARDS_HUB_WIDGET = "RewardsPopUpRootWidget", //Legacy widget name for backward compatibility with customizations
    REWARDS_HUB_WIDGET_V2 = "RewardsHubWidgetV2",
    REWARDS_HUB_B2B_WIDGET = "RewardsHubB2bWidget",
    REWARDS_CRITICAL_DRAWER_WIDGET = "RewardsCriticalDrawerWidget",
    REWARDS_VERIFY_ACCOUNT_MODAL_WIDGET = "RewardsVerifyAccountModalWidget",
    REWARDS_JOIN_NOW_MODAL_WIDGET = "RewardsJoinNowModalWidget",
    REWARDS_WAYS_TO_EARN_PAGE_WIDGET = "RewardsWaysToEarnPageWidget",
    REWARDS_WAYS_TO_EARN_B2B_PAGE_WIDGET = "RewardsWaysToEarnB2bPageWidget",
    REWARDS_WAYS_TO_EARN_PAGE_WIDGET_MODAL = "RewardsWaysToEarnPageWidgetModal",
    REWARDS_WAYS_TO_EARN_B2B_PAGE_WIDGET_MODAL = "RewardsWaysToEarnB2bPageWidgetModal",
    REWARDS_WAYS_TO_SPEND_PAGE_WIDGET = "RewardsWaysToSpendPageWidget",
    REWARDS_WAYS_TO_SPEND_B2B_PAGE_WIDGET = "RewardsWaysToSpendB2bPageWidget",
    REWARDS_WAYS_TO_SPEND_PAGE_WIDGET_MODAL = "RewardsWaysToSpendPageWidgetModal",
    REWARDS_WAYS_TO_SPEND_B2B_PAGE_WIDGET_MODAL = "RewardsWaysToSpendB2bPageWidgetModal",
    REWARDS_AVAILABLE_REWARDS_PAGE_WIDGET = "RewardsAvailableRewardsPageWidget",
    REWARDS_AVAILABLE_REWARDS_B2B_PAGE_WIDGET = "RewardsAvailableRewardsB2bPageWidget",
    REWARDS_AVAILABLE_REWARDS_PAGE_WIDGET_MODAL = "RewardsAvailableRewardsPageWidgetModal",
    REWARDS_AVAILABLE_REWARDS_B2B_PAGE_WIDGET_MODAL = "RewardsAvailableRewardsB2BPageWidgetModal",
    REWARDS_AVAILABLE_STORE_CREDIT_PAGE_WIDGET_MODAL = "RewardsAvailableStoreCreditPageWidgetModal",
    REWARDS_VIP_TIERS_PAGE_WIDGET = "RewardsVipTiersPageWidget",
    REWARDS_VIP_TIERS_CARD_WIDGET = "RewardsVipTiersCardWidget",
    REWARDS_VIP_TIERS_SINGLE_PROGRESS_WIDGET = "RewardsVipTiersSingleProgressWidget",
    REWARDS_VIP_TIERS_SINGLE_PROGRESS_WIDGET_V2 = "RewardsVipTiersSingleProgressWidgetV2",
    REWARDS_VIP_TIERS_MULTI_PROGRESS_WIDGET = "RewardsVipTiersMultiProgressWidget",
    REWARDS_REFERRAL_PROGRAM_PAGE_WIDGET = "RewardsReferralProgramPageWidget",
    REWARDS_REFERRALS_PAGE_WIDGET = "RewardsReferralsPageWidget",
    REWARDS_HISTORY_PAGE_WIDGET = "RewardsHistoryPageWidget",
    REWARDS_FAQ_PAGE_WIDGET = "RewardsFaqPageWidget",
    REWARDS_EARN_POINTS_PRODUCT_PAGE_WIDGET = "RewardsEarnPointsProductPageWidget",
    REWARDS_EARN_POINTS_CART_WIDGET = "RewardsEarnPointsCartWidget",
    REWARDS_EMPTY_STATE_PAGE_WIDGET = "RewardsEmptyStatePageWidget",
    REWARDS_LOYALTY_INFO_PAGE_WIDGET = "RewardsLoyaltyInfoPageWidget",
    REWARDS_LOYALTY_INFO_PAGE_WIDGET_V2 = "RewardsLoyaltyInfoPageWidgetV2",
    REWARDS_QR_CODE_MODAL_WIDGET = "RewardsQrCodeModalWidget",
    REWARDS_CUSTOMER_POINTS_BALANCE_INLINE_WIDGET = "RewardsCustomerPointsBalanceInlineWidget",
    REWARDS_AVAILABLE_REWARDS_LIST_WIDGET = "RewardsAvailableRewardsListWidget",
    REWARDS_AVAILABLE_REWARDS_CART_WIDGET = "RewardsAvailableRewardsCartWidget",
    REWARDS_REFUND_DISCOUNT_MODAL_WIDGET = "RewardsRefundDiscountModalWidget",
    REWARDS_FREE_PRODUCT_SLIDER_WIDGET = "RewardsFreeProductSliderWidget",
}

export enum REVIEWS_WIDGET_NAMES {
    REVIEWS_WIDGET = "ReviewsWidget",
    REVIEWS_DRAWER_WIDGET = "ReviewsDrawerWidget",
    REVIEWS_PRODUCT_PAGE_WIDGET = "ReviewsProductPageWidget",
    PRODUCT_REVIEWS_MINI_SLIDER_WIDGET = "ProductReviewsMiniSliderWidget",
    REVIEWS_PAGE_WIDGET = "ReviewsPageWidget",
    LEAVE_REVIEW_PAGE_WIDGET = "LeaveReviewPageWidget",
    AVERAGE_REVIEWS_WIDGET = "AverageReviewsWidget",
    REVIEWS_STAR_RATING_WIDGET = "ReviewsStarRatingWidget",
    REVIEWS_SLIDER_WIDGET = "ReviewsSliderWidget",
    LISTING_AVERAGE_REVIEWS_WIDGET = "ListingAverageReviewsWidget",
    LISTING_AVERAGE_REVIEWS_WIDGET_V2 = "ListingAverageReviewsWidgetV2",
    REVIEWS_EDIT_FORM_MODAL_WIDGET = "ReviewsEditFormModalWidget",
    REVIEWS_FORM_MODAL_WIDGET = "ReviewsFormModalWidget",
    QUESTIONS_FORM_MODAL_WIDGET = "QuestionsFormModalWidget",
    REVIEWS_GALLERY_WIDGET = "ReviewsGalleryWidget",
    REVIEWS_GALLERY_MODAL_WIDGET = "ReviewsGalleryModalWidget",
    REVIEWS_LIST_WIDGET = "ReviewsListWidget",
    REVIEWS_LIST_HEADER_WIDGET = "ReviewsListHeaderWidget",
    QUESTIONS_LIST_WIDGET = "QuestionsListWidget",
    REVIEWS_TRUST_BADGE_WIDGET = "ReviewsTrustBadgeWidget",
    LEAVE_REVIEW_BUTTON_WIDGET = "LeaveReviewButtonWidget",
}

export enum WISHLIST_WIDGET_NAMES {
    WISHLISTS_WIDGET = "WishlistsWidget",
    ADD_TO_WISHLIST_PRODUCT_CARD_WIDGET = "AddToWishlistProductCardWidget",
    ADD_TO_WISHLIST_BUTTON_WIDGET = "AddToWishlistButtonWidget",
    ADD_TO_WISHLIST_PRODUCT_PAGE_WIDGET = "AddToWishlistProductPageWidget",
    GO_TO_WISHLIST_PAGE_HEADER_WIDGET = "GoToWishlistPageHeaderWidget",
    WISHLIST_PAGE_WIDGET = "WishlistPageWidget",
    WISHLIST_DRAWER_WIDGET = "WishlistDrawerWidget",
    SHARED_WISHLIST_PAGE_WIDGET = "SharedWishlistPageWidget",
    SAVE_WISHLIST_MODAL_WIDGET = "SaveWishlistModalWidget",
    WISHLISTS_MANAGE_APPROVERS_MODAL_WIDGET = "WishlistsManageApproversModalWidget",
    WISHLISTS_ITEMS_TOTAL_COUNT_INLINE_WIDGET = "WishlistsItemsTotalCountInlineWidget",
    SAVE_FOR_LATER_MODAL_WIDGET = "SaveForLaterModalWidget",
}

export enum INSTAGRAM_WIDGET_NAMES {
    INSTAGRAM_GALLERY_WIDGET = "InstagramGalleryWidget",
}

export enum TIKTOK_WIDGET_NAMES {
    TIKTOK_GALLERY_WIDGET = "TikTokGalleryWidget",
}

export enum NUDGES_WIDGET_NAMES {
    NUDGES_WIDGET = "NudgesWidget",
}

export enum GIFT_REGISTRY_WIDGET_NAMES {
    ADD_TO_REGISTRY_PRODUCT_PAGE_WIDGET = "AddToRegistryProductPageWidget",
    ADD_TO_REGISTRY_MODAL_WIDGET = "AddToRegistryModalWidget",
    SHARED_REGISTRY_PAGE_WIDGET = "SharedRegistryPageWidget",
    REGISTRY_FORM_MODAL_WIDGET = "RegistryFormModalWidget",
    GIFT_CART_DRAWER_WIDGET = "GiftCartDrawerWidget",
    GIFT_REGISTRY_PAGE_WIDGET = "GiftRegistryPageWidget",
}
